import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Card, CardBody, CardHeader, Button, Alert } from "reactstrap";
import LoadingScreen from "react-loading-screen";
import Page from "../../../../components/Page";
import moment from "moment";



// Redux
import {
  listarCompromisos,
  limpiarNuevoCompromiso,
  configuracionCompromisos
} from "../../redux/aCompromisos";
import {
  selectCompromisos,
  selectCompromisosLoading
} from "../../redux/selectors";

// Componentes
import TablaCompromisos from "../../components/TablaCompromisos/index";
import FiltrosCompromisos from "../../components/FiltrosCompromisos/index";

const ListadoCompromisos = () => {

  // Selectors
  const dispatch = useDispatch();
  const history = useHistory();
  const compromisos = useSelector(selectCompromisos);
  const compromisoLoading = useSelector(selectCompromisosLoading);
  const datosUsuario = useSelector(
    (state) => state.datosUsuarios.dataUsuario
  );

  const puedeVerTiempoCreacion = [
    "admin-user",
    "soporte-user",
    "distribucion-user",
    /*Suscripción */
    "lineas-personales-user",
    "hogar-user",
    "pymes-user",
    "accidentes-personales-user",
    "responsabilidad-civil-user",
    "lineas-financieras-user",
    "vehiculos-user",
  ].includes(
    datosUsuario && datosUsuario.usu_tipo_usuario
  );

  const [diasConfiguracion, setDiasConfiguracion] = useState(90);
  const [filtros, setFiltros] = useState({
    fechaDesde: moment().subtract(diasConfiguracion, "days").toDate(),
    fechaHasta: new Date()
  });
  const [compromisosVista, setCompromisosVista] = useState(compromisos);

  const handleFiltroChange = (nombre, valor) => {
    setFiltros((prev) => ({
      ...prev,
      [nombre]: valor
    }));
  };

  const obtenerParametrosListado = (valores) => ({
    fechaInicio: valores.fechaDesde
      ? moment(valores.fechaDesde).format("YYYY-MM-DD")
      : null,
    fechaFin: valores.fechaHasta
      ? moment(valores.fechaHasta).format("YYYY-MM-DD")
      : null,
    rol:
      datosUsuario
        ? datosUsuario.usu_tipo_usuario
        : null,
    idUsuario:
      datosUsuario
        ? datosUsuario.cliCodigoCore
        : null,
    brokerRuc: datosUsuario
      ? datosUsuario.brokerRUC
      : null,
    brokerCodigo: datosUsuario
      ? datosUsuario.brokerCodigo
      : null,

  });

  const handleFiltrar = async () => {
    const datos = await dispatch(listarCompromisos(obtenerParametrosListado(filtros)));
    setCompromisosVista(datos);
  };

  const handleLimpiar = async () => {
    const rangoInicial = {
      fechaDesde: moment().subtract(diasConfiguracion, "days").toDate(),
      fechaHasta: new Date()
    };
    setFiltros({
      ...rangoInicial
    });
    const datos = await dispatch(listarCompromisos(obtenerParametrosListado(rangoInicial)));
    setCompromisosVista(datos);
  };

  useEffect(() => {

  dispatch(limpiarNuevoCompromiso());

}, [dispatch]);

  useEffect(() => {
    const cargarConfiguracion = async () => {
      try {
        const response =  await dispatch(configuracionCompromisos());
        const dias = Number(response && response.data && response.data.dias);
        const diasValidos = response && response.success === true && Number.isFinite(dias) && dias >= 0
          ? dias
          : 90;
        const rangoInicial = {
          fechaDesde: moment().subtract(diasValidos, "days").toDate(),
          fechaHasta: new Date()
        };

        setDiasConfiguracion(diasValidos);
        setFiltros((prev) => ({
          ...prev,
          ...rangoInicial
        }));
        const datos = await dispatch(listarCompromisos(obtenerParametrosListado(rangoInicial)));
        setCompromisosVista(datos);
      } catch (error) {
        const datos = await dispatch(listarCompromisos(obtenerParametrosListado(filtros)));
        setCompromisosVista(datos);
      }
    };

    cargarConfiguracion();
  }, [dispatch]);



  return (
    <main className="bg-light">
      <div className="cr-content container-fluid">
        <div className="container-body-spaces">
          <LoadingScreen
            loading={compromisoLoading}
            bgColor="#ffffff"
            spinnerColor="#007bff"
            textColor="#676767"
            text="Cargando compromisos..."
          >

            <Page
              title={
                "Revisa tus compromisos"
              }
              breadcrumbs={[
                {
                  name:
                    "Compromisos",
                  active: true,
                },
              ]}
              action={
                <Button style={{
                  backgroundColor: "#001873",
                  borderColor: "#001873",
                  color: "#ffffff",
                  borderRadius: "4px",
                  fontWeight: "500"
                }} onClick={() => history.push('/compromisos/crear')}>
                  + Crear compromiso
                </Button>
              }
            >
              <FiltrosCompromisos
                filtros={filtros}
                onChange={handleFiltroChange}
                onFiltrar={handleFiltrar}
                onLimpiar={handleLimpiar}
              />
              {/* Listado */}

              <Card className="shadow-sm border-0">
                <CardHeader className="bg-white py-3 border-bottom-0">

                </CardHeader>
                <CardBody className="pt-0">
                  <TablaCompromisos
                    compromisos={compromisosVista}
                    isLoading={compromisoLoading}
                    puedeVerTiempoCreacion={puedeVerTiempoCreacion}
                  />
                </CardBody>
              </Card>

            </Page>
          </LoadingScreen>
        </div>
      </div>
    </main>
  );
};

export default ListadoCompromisos;